import React, { Component } from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  Input,
  InputLabel,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Tooltip,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import Filter9PlusIcon from '@mui/icons-material/Filter9Plus';
import PlusOneIcon from '@mui/icons-material/PlusOne';
import { toast } from 'react-toastify';

import ServiceCommandUnit from './ServiceCommandUnit';
import ManageReportDataApi from '../../Api/ApiManageReportData';
import appdata from '../../Services/appdata';
import './style.css';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const getItemStyle = (isDragging, draggableStyle, selectedGroup, groupId) => ({
  userSelect: 'none',
  background: isDragging
    ? 'lightgreen'
    : selectedGroup === groupId
    ? 'grey'
    : '#e5e5e5',
  border: '1px solid #c0c0c0',
  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? 'lightblue' : 'white',
  cursor: 'pointer',
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

let timer;

class PNLTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      selectedCompany: -1,
      accountTypes: [],
      selectedAccounts: [],
      rows: [],
      profit: 'Profit / Loss',
      pprofit: '% Profit',
      selectedGroup: -1,
      selectedAccount: -1,
      selectedParent: -1,
      accountDialogOpen: false,
      groupAddDialogOpen: false,
      groupUpdateDialogOpen: false,
      totalDialogOpen: false,
      deleteDialogOpen: false,
      newAccounts: [],
      newGroup: '',
      newTotal: '',
      groupType: '',
      alreadyIncluded: false,
      incomeCalc: false,
    };
  }

  async componentDidMount() {
    const company_org_id = appdata.getItem('company_org_id');
    let comps = [];
    await Promise.all([
      ManageReportDataApi.getCompanies()
        .then((res) => {
          if (res.status === 200) comps = res.data;
          else toast.error(res.message);
        })
        .catch((error) => toast.error(error.message)),
      this.props.getTemplateData('PNL', company_org_id),
    ]);
    this.setState({
      companies: comps,
      selectedCompany: company_org_id,
    });
    
    requestAnimationFrame(function () {
      const event = new UIEvent('resize', {
        bubbles: true,
        cancelable: false,
        view: window
      });
      window.dispatchEvent(event);
    });
  }

  componentWillUnmount() {
    this.setState({ rows: [] });
  }

  async componentDidUpdate(prevProps) {
    if (this.props.rows && prevProps.rows !== this.props.rows) {

      let rows = this.props.rows[0];
      let accountTypes = this.props.rows[1];
      let selectedAccounts = [];
      rows.map((row) =>
        row.total
          ? row.subItems &&
            row.subItems.map((item) => selectedAccounts.push(item.content))
          : null,
      );
      this.setState({
        rows,
        accountTypes,
        selectedAccounts,
      });
    }
  }

  handleSelectCompany = async (ev) => {
    appdata.setItem('company_org_id', ev.target.value);
    this.setState({ selectedCompany: ev.target.value });
    await this.props.getTemplateData('PNL', ev.target.value);
  };

  onDragEnd = async (result) => {
    if (!result.destination) {
      return;
    }
    const sourceIndex = result.source.index;
    const destIndex = result.destination.index;
    if (result.type === 'droppableItem') {
      const rows = reorder(this.state.rows, sourceIndex, destIndex);

      this.setState({
        rows,
      });
      await ManageReportDataApi.updateTemplate(
        this.props.name,
        JSON.stringify(rows),
      );
    } else if (result.type === 'droppableSubItem') {
      const itemSubItemMap = this.state.rows.reduce((acc, item) => {
        acc[item.id] = item.subItems;
        return acc;
      }, {});

      const sourceParentId = parseInt(result.source.droppableId);
      const destParentId = parseInt(result.destination.droppableId);

      const sourceSubItems = itemSubItemMap[sourceParentId];
      const destSubItems = itemSubItemMap[destParentId];

      let newItems = [...this.state.rows];

      if (sourceParentId === destParentId) {
        const reorderedSubItems = reorder(
          sourceSubItems,
          sourceIndex,
          destIndex,
        );

        newItems = newItems.map((item) => {
          if (item.id === sourceParentId) {
            item.subItems = reorderedSubItems;
          }
          return item;
        });
        this.setState({
          rows: newItems,
        });

        await ManageReportDataApi.updateTemplate(
          this.props.name,
          JSON.stringify(newItems),
        );
      } else {
        let newSourceSubItems = [...sourceSubItems];
        const [draggedItem] = newSourceSubItems.splice(sourceIndex, 1);

        let newDestSubItems = [...destSubItems];
        newDestSubItems.splice(destIndex, 0, draggedItem);

        newItems = newItems.map((item) => {
          if (item.id === sourceParentId) {
            item.subItems = newSourceSubItems;
          } else if (item.id === destParentId) {
            item.subItems = newDestSubItems;
          }
          return item;
        });

        this.setState({
          rows: newItems,
        });

        await ManageReportDataApi.updateTemplate(
          this.props.name,
          JSON.stringify(newItems),
        );
      }
    }
  };

  handleToggleGroup(e, groupId) {
    clearTimeout(timer);
    if (e.detail === 1)
      timer = setTimeout(() => this.onClickGroup(groupId), 200);
    else if (e.detail === 2) this.onDoubleClickGroup(groupId);
  }

  onClickGroup = (groupId) => {
    if (groupId !== this.state.selectedGroup)
      this.setState({
        selectedGroup: groupId,
        selectedAccount: -1,
        selectedParent: -1,
      });
    else
      this.setState({
        selectedGroup: -1,
      });
  };

  onDoubleClickGroup = (groupId) => {
    let { rows } = this.state;
    let group = rows.find((row) => row.id === groupId);
    if (group.total)
      this.setState({
        groupUpdateDialogOpen: true,
        selectedGroup: groupId,
        groupType: group.income ? 'Income' : 'Expense',
        alreadyIncluded: group.alreadyIncluded,
        incomeCalc: group.incomeCalc,
        editGroup: group.content,
        editGroupTotal: group.totalTitle,
      });
  };

  updatePNLStrucuture = async () => {
    await ManageReportDataApi.updateTemplate(
      this.props.name,
      JSON.stringify(this.state.rows),
    );
  };

  _handleKeyDown = async (e) => {
    if (e.key === 'Enter') {
      await ManageReportDataApi.updateTemplate(
        this.props.name,
        JSON.stringify(this.state.rows),
      );
      this.handleDialogClose();
    }
  };

  handleToggleAccount = (e, groupId, type, accountId) => {
    e.preventDefault();
    e.stopPropagation();
    if (accountId !== this.state.selectedAccount) {
      this.setState({
        selectedAccount: accountId,
        selectedGroup: -1,
        selectedParent: type,
      });
    } else {
      this.setState({
        selectedAccount: -1,
      });
    }
  };

  handleDialogClose = () => {
    this.setState({
      selectedGroup: -1,
      selectedAccount: -1,
      selectedParent: -1,
      accountDialogOpen: false,
      groupAddDialogOpen: false,
      groupUpdateDialogOpen: false,
      totalDialogOpen: false,
      deleteDialogOpen: false,
      newAccounts: [],
      newGroup: '',
      newTotal: '',
      groupType: '',
      alreadyIncluded: false,
      incomeCalc: false,
    });
  };

  handleClickAddAccount() {
    if (this.state.selectedGroup === -1)
      toast.warning(
        'Please select the group that insert the account.',
      );
    else
      this.setState({
        accountDialogOpen: true,
      });
  }

  handleSelectAccountTypes(event) {
    this.setState({
      newAccounts: event.target.value,
    });
  }

  handleAddNewAccount = async () => {
    if (this.state.newAccounts.length === 0)
      toast.warning('Please select the new accounts.');
    else {
      let group = this.state.rows.find(
        (group) => group.id === this.state.selectedGroup,
      );
      let maxId = group.subItems.reduce(
        (acc, shot) => (acc = acc > shot.id ? acc : shot.id),
        0,
      );

      let { rows } = this.state;
      rows.map((item) => {
        if (item.id === this.state.selectedGroup) {
          this.state.newAccounts.forEach((account) => {
            maxId++;
            item.subItems.push({
              id: maxId,
              content: account,
            });
          });
        }
        return item;
      });
      let selectedAccounts = [];
      rows.map(
        (row) =>
          row.subItems &&
          row.subItems.map((item) => selectedAccounts.push(item.content)),
      );
      this.setState({
        rows,
        selectedAccounts,
      });
      await ManageReportDataApi.updateTemplate(
        this.props.name,
        JSON.stringify(this.state.rows),
      );
      this.handleDialogClose();
    }
  };

  handleChangeGroupType = (e) => {
    this.setState({
      groupType: e.target.value,
    });
  };

  handleChangeIncludeIncome = (event) => {
    this.setState({
      alreadyIncluded: event.target.checked,
    });
  };

  handleChangeIncomeCalc = (event) => {
    this.setState({
      incomeCalc: event.target.checked,
    });
  };

  handleAddNewGroup = async () => {
    if (this.state.newGroup === '')
      toast.warning('Please input the new group name.');
    else if (this.state.groupType === '')
      toast.warning('Please check the group type.');
    else {
      let { rows } = this.state;
      let maxId = rows.reduce(
        (acc, shot) => (acc = acc > shot.id ? acc : shot.id),
        0,
      );

      rows.push({
        id: maxId + 1,
        content: this.state.newGroup,
        income: this.state.groupType === 'Income' ? true : false,
        alreadyIncluded: this.state.alreadyIncluded,
        incomeCalc: this.state.incomeCalc,
        total: true,
        totalTitle: `Total ${this.state.newGroup}`,
        subItems: [],
      });
      this.setState({ rows });
      await ManageReportDataApi.updateTemplate(
        this.props.name,
        JSON.stringify(rows),
      );
      this.handleDialogClose();
    }
  };

  handleUpdateGroupType = async () => {
    if (this.state.editGroup === '')
      toast.warning('Please input the group name.');
    else if (this.state.editGroupTotal === '') {
      toast.warning('Please input the group total name.');
    } else if (this.state.groupType === '')
      toast.warning('Please check the group type.');
    else {
      let { rows } = this.state;
      rows.map((row) => {
        if (row.id === this.state.selectedGroup) {
          row.income = this.state.groupType === 'Income' ? true : false;
          row.alreadyIncluded = this.state.alreadyIncluded;
          row.incomeCalc = this.state.incomeCalc;
          row.content = this.state.editGroup;
          row.totalTitle = this.state.editGroupTotal;
        }
        return row;
      });

      this.setState({ rows });

      await this.updatePNLStrucuture();
      this.handleDialogClose();
    }
  };

  handleAddNewTotal = async () => {
    if (this.state.newTotal === '')
      toast.warning('Please input the new total name.');
    else {
      let { rows } = this.state;
      let maxId = rows.reduce(
        (acc, shot) => (acc = acc > shot.id ? acc : shot.id),
        0,
      );
      rows.push({
        id: maxId + 1,
        content: this.state.newTotal,
        total: false,
      });
      this.setState({ rows });
      await ManageReportDataApi.updateTemplate(
        this.props.name,
        JSON.stringify(rows),
      );
      this.handleDialogClose();
    }
  };

  handleClickDeleteAccount = () => {
    if (this.state.selectedGroup === -1 && this.state.selectedAccount === -1)
      toast.warning(
        'Please select the group or account that have to delete.',
      );
    else {
      this.setState({
        deleteDialogOpen: true,
      });
    }
  };

  handleDeleteItem = async () => {
    if (this.state.selectedGroup !== -1) {
      let rows = this.state.rows.filter(
        (item) => item.id !== this.state.selectedGroup,
      );
      let selectedAccounts = [];
      rows.map(
        (row) =>
          row.subItems &&
          row.subItems.map((item) => selectedAccounts.push(item.content)),
      );
      this.setState({ rows, selectedAccounts });
      if (rows.length === 0)
        await ManageReportDataApi.updateTemplate(this.props.name, null);
      else
        await ManageReportDataApi.updateTemplate(
          this.props.name,
          JSON.stringify(rows),
        );
    } else {
      let { rows } = this.state;
      rows.map((item) => {
        if (item.id === this.state.selectedParent) {
          item.subItems = item.subItems.filter(
            (account) => account.id !== this.state.selectedAccount,
          );
        }
        return item;
      });

      let selectedAccounts = [];
      rows.map(
        (row) =>
          row.subItems &&
          row.subItems.map((item) => selectedAccounts.push(item.content)),
      );
      this.setState({
        rows,
        selectedAccounts,
      });
      await ManageReportDataApi.updateTemplate(
        this.props.name,
        JSON.stringify(rows),
      );
    }
    this.handleDialogClose();
  };

  handleChangeGroupName = (event, item) => {
    const { rows } = this.state;
    rows.map((row) =>
      row.id === item.id ? (row.content = event.target.value) : row,
    );
    this.setState({ rows });
  };

  handleChangeTotalName = (event, item) => {
    const { rows } = this.state;
    rows.map((row) =>
      row.id === item.id ? (row.totalTitle = event.target.value) : row,
    );
    this.setState({ rows });
  };

  render() {
    const {
      companies,
      selectedCompany,
      accountDialogOpen,
      groupAddDialogOpen,
      groupUpdateDialogOpen,
      totalDialogOpen,
      deleteDialogOpen,
      selectedGroup,
      accountTypes,
      selectedAccounts,
      newAccounts,
      rows,
      groupType,
      alreadyIncluded,
      incomeCalc,
      editGroup,
      editGroupTotal,
    } = this.state;

    return (
      <>
        <Grid
          container
          style={{
            border: '1px solid #e7eaec',
            backgroundColor: 'white',
            height: 48,
            position: 'fixed',
            width: '74%',
            zIndex: 1,
          }}
        >
          <Grid size={6}>
            <label style={{ marginLeft: 8, marginTop: 12 }}>Company : </label>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
              <Select
                value={selectedCompany}
                onChange={this.handleSelectCompany}
              >
                <MenuItem value={-1} disabled>
                  {' '}
                </MenuItem>
                {companies &&
                  companies.map(
                    (cur) =>
                      cur.IsActive && (
                        <MenuItem key={cur.id} value={cur.id}>
                          {cur.CompanyName}
                        </MenuItem>
                      ),
                  )}
              </Select>
            </FormControl>
          </Grid>
          {selectedCompany !== -1 ? (
            <Grid
              size={6}
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              <Tooltip title="Add Account">
                <IconButton
                  aria-label="account-add"
                  onClick={() => this.handleClickAddAccount()}
                >
                  <AddIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Add Group">
                <IconButton
                  aria-label="group-add"
                  onClick={() =>
                    this.setState({
                      groupAddDialogOpen: true,
                    })
                  }
                >
                  <Filter9PlusIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Add Total">
                <IconButton
                  aria-label="total-add"
                  onClick={() =>
                    this.setState({
                      totalDialogOpen: true,
                    })
                  }
                >
                  <PlusOneIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton
                  aria-label="Delete"
                  onClick={this.handleClickDeleteAccount}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          ) : null}
        </Grid>

        <Grid size={12} style={{ height: '89vh', overflowY: 'auto' }}>
          <DragDropContext onDragEnd={this.onDragEnd}>
            <Droppable droppableId="droppable" type="droppableItem">
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  <div style={{ marginTop: 48 }}>
                    {rows.map((item, index) => (
                      <Draggable
                        key={item.id}
                        draggableId={item.id.toString()}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <div>
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              style={getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style,
                                this.state.selectedGroup,
                                item.id,
                              )}
                              onClick={(e) =>
                                this.handleToggleGroup(e, item.id)
                              }
                              onKeyDown={this._handleKeyDown}
                            >
                              <span
                                {...provided.dragHandleProps}
                                style={{
                                  display: 'inline-block',
                                  margin: '13px 10px 9px 20px',
                                  width: 30,
                                  verticalAlign: 'middle',
                                }}
                              >
                                <DragIndicatorIcon />
                              </span>
                              <TextField
                                value={item.content}
                                style={{ width: 500 }}
                                onChange={(e) =>
                                  this.handleChangeGroupName(e, item)
                                }
                                onBlur={this.updatePNLStrucuture}
                                size="small"
                                variant="standard"
                              />
                              {item.total ? (
                                <ServiceCommandUnit
                                  subItems={item.subItems}
                                  type={item.id}
                                  selectedAccount={this.state.selectedAccount}
                                  handleToggle={this.handleToggleAccount}
                                />
                              ) : null}
                              {item.total ? (
                                <div
                                  style={{
                                    height: 50,
                                    display: 'flex',
                                    alignItems: 'center',
                                    paddingLeft: 35,
                                  }}
                                >
                                  <TextField
                                    value={item.totalTitle}
                                    style={{ width: 500 }}
                                    onChange={(e) =>
                                      this.handleChangeTotalName(e, item)
                                    }
                                    onBlur={this.updatePNLStrucuture}
                                    size="small"
                                    variant="standard"
                                  />
                                </div>
                              ) : null}
                            </div>
                            {provided.placeholder}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </Grid>

        <Dialog
          open={accountDialogOpen}
          onClose={() => this.handleDialogClose()}
          aria-labelledby="add-account-dialog"
        >
          <DialogTitle id="add-account-dialog">Add Account</DialogTitle>
          <DialogContent>
            <DialogContentText>
              To add the account in the group, please enter the account name
              here.
            </DialogContentText>
            <FormControl>
              <InputLabel id="select-account-label">Account Types</InputLabel>
              <Select
                multiple
                labelId="select-account-label"
                id="select-account"
                value={newAccounts}
                style={{ margin: 12, minWidth: 120, maxWidth: 300 }}
                input={<Input />}
                MenuProps={MenuProps}
                onChange={(e) => this.handleSelectAccountTypes(e)}
              >
                {accountTypes &&
                  accountTypes.map((account, index) => (
                    <MenuItem
                      key={index}
                      value={account.AccountTypeCode}
                      disabled={
                        selectedAccounts.includes(account.AccountTypeCode)
                          ? true
                          : false
                      }
                    >
                      {account.AccountTypeCode}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                backgroundColor: '#e0e0e0',
                color: 'rgba(0, 0, 0, 0.87)',
              }}
              onClick={() => this.handleDialogClose()}
            >
              Cancel
            </Button>
            <Button
              style={{
                backgroundColor: '#1976d2',
                color: '#ffffff',
              }}
              onClick={this.handleAddNewAccount}
            >
              Add
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={groupAddDialogOpen}
          onClose={() => this.handleDialogClose()}
          aria-labelledby="add-group-dialog"
        >
          <DialogTitle id="add-group-dialog">Add Group</DialogTitle>
          <DialogContent>
            <DialogContentText>
              To add the group, please enter the group name and check the type
              here.
            </DialogContentText>
            <RadioGroup
              row
              aria-label="position"
              name="position"
              defaultValue="top"
              value={groupType}
              onChange={this.handleChangeGroupType}
            >
              <FormControlLabel
                value="Income"
                control={<Radio color="primary" />}
                label="Income"
              />
              <FormControlLabel
                value="Expense"
                control={<Radio color="primary" />}
                label="Expense"
              />
            </RadioGroup>
            {groupType === 'Income' && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={alreadyIncluded}
                    onChange={this.handleChangeIncludeIncome}
                    color="success"
                  />
                }
                label="Income already included in gross income"
                labelPlacement="end"
              />
            )}
            <FormControlLabel
              control={
                <Checkbox
                  checked={incomeCalc}
                  onChange={this.handleChangeIncomeCalc}
                  color="success"
                />
              }
              label="Total income for expense calculation"
              labelPlacement="end"
            />
            <TextField
              autoFocus
              margin="dense"
              id="group"
              label="Group Name"
              type="text"
              fullWidth
              onChange={(e) =>
                this.setState({
                  newGroup: e.target.value,
                })
              }
            />
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                backgroundColor: '#e0e0e0',
                color: 'rgba(0, 0, 0, 0.87)',
              }}
              onClick={() => this.handleDialogClose()}
            >
              Cancel
            </Button>
            <Button
              style={{
                backgroundColor: '#1976d2',
                color: '#ffffff',
              }}
              onClick={this.handleAddNewGroup}
            >
              Add
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={groupUpdateDialogOpen}
          onClose={() => this.handleDialogClose()}
          aria-labelledby="add-group-dialog"
        >
          <DialogTitle id="add-group-dialog">Update Group Type</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please check the group type again.
            </DialogContentText>
            <RadioGroup
              row
              aria-label="position"
              name="position"
              defaultValue="top"
              value={groupType}
              onChange={this.handleChangeGroupType}
            >
              <FormControlLabel
                value="Income"
                control={<Radio color="primary" />}
                label="Income"
              />
              <FormControlLabel
                value="Expense"
                control={<Radio color="primary" />}
                label="Expense"
              />
            </RadioGroup>
            {groupType === 'Income' && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={alreadyIncluded}
                    onChange={this.handleChangeIncludeIncome}
                    color="success"
                  />
                }
                label="Income already included in gross income"
                labelPlacement="end"
              />
            )}
            <FormControlLabel
              control={
                <Checkbox
                  checked={incomeCalc}
                  onChange={this.handleChangeIncomeCalc}
                  color="success"
                />
              }
              label="Total income for expense calculation"
              labelPlacement="end"
            />
            <TextField
              margin="dense"
              id="group"
              label="Group Name"
              type="text"
              fullWidth
              value={editGroup}
              onChange={(e) =>
                this.setState({
                  editGroup: e.target.value,
                })
              }
            />
            <TextField
              margin="dense"
              id="group"
              label="Group Total Name"
              type="text"
              fullWidth
              value={editGroupTotal}
              onChange={(e) =>
                this.setState({
                  editGroupTotal: e.target.value,
                })
              }
            />
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                backgroundColor: '#e0e0e0',
                color: 'rgba(0, 0, 0, 0.87)',
              }}
              onClick={() => this.handleDialogClose()}
            >
              Cancel
            </Button>
            <Button
              style={{
                backgroundColor: '#1976d2',
                color: '#ffffff',
              }}
              onClick={this.handleUpdateGroupType}
            >
              Update
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={totalDialogOpen}
          onClose={this.handleDialogClose}
          aria-labelledby="add-total-dialog"
        >
          <DialogTitle id="add-total-dialog">Add Total</DialogTitle>
          <DialogContent>
            <DialogContentText>
              To add the total, please enter the total name here.
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="total"
              label="Total Name"
              type="text"
              fullWidth
              onChange={(e) =>
                this.setState({
                  newTotal: e.target.value,
                })
              }
            />
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                backgroundColor: '#e0e0e0',
                color: 'rgba(0, 0, 0, 0.87)',
              }}
              onClick={this.handleDialogClose}
            >
              Cancel
            </Button>
            <Button
              style={{
                backgroundColor: '#1976d2',
                color: '#ffffff',
              }}
              onClick={this.handleAddNewTotal}
            >
              Add
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={deleteDialogOpen}
          onClose={this.handleDialogClose}
          aria-labelledby="delete-dialog"
        >
          <DialogTitle id="delete-dialog">
            Delete selected {selectedGroup !== -1 ? 'Group' : 'Account'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Do you want to delete the selected{' '}
              {selectedGroup !== -1 ? 'group' : 'account'} ?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                backgroundColor: '#e0e0e0',
                color: 'rgba(0, 0, 0, 0.87)',
              }}
              onClick={this.handleDialogClose}
            >
              Disagree
            </Button>
            <Button
              style={{
                backgroundColor: '#1976d2',
                color: '#ffffff',
              }}
              onClick={this.handleDeleteItem}
            >
              Agree
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default PNLTable;
